import React from "react";

import ReusableEdit from "../ReusableEdit";

function Edit() {
  return <ReusableEdit title={'Training'}></ReusableEdit>;
}

export default Edit;
